import { render } from "./TopbarProgetti.vue?vue&type=template&id=f78cbe72&ts=true"
import script from "./TopbarProgetti.vue?vue&type=script&lang=ts"
export * from "./TopbarProgetti.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__